export interface Article {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  tags: string[];
  coverImage: string;
  author: string;
  publishedAt: string;
  views: number;
  comments: number;
  isHot: boolean;
  isTrending: boolean;
  slug: string;
}

export const articles: Article[] = [
  {
    id: 1,
    title: "某顶流男星深夜约会神秘女子，酒店共度8小时全程被拍",
    excerpt: "据知情人士透露，该顶流男星与一名圈外女子在某五星级酒店被拍到同进同出，两人举止亲密，疑似新恋情曝光。粉丝们炸锅了！",
    content: `<p>近日，知名娱记"摄影师小杰"在某社交平台曝光了一组劲爆照片，照片中一位当前娱乐圈最炙手可热的顶流男星，深夜与一名神秘女子在某五星级酒店同进同出，两人全程互动亲密。</p><p>据目击者称，当晚约11点，该男星独自一人低调进入酒店。约20分钟后，一名身着黑色吊带裙的长发女子也进入同一酒店。直到第二天早上7点，两人才一前一后分别离开酒店，前后共停留约8小时。</p><p>值得一提的是，该男星此前一直以"单身"人设示人，在多次采访中均表示自己目前专注事业、无心恋爱。此次被拍到与神秘女子酒店共度一夜，无疑是对其"单身人设"的一记重击。</p><p>截至目前，该男星及其工作室尚未对此事作出任何回应。而其粉丝群体已经分裂为两派：一派认为"艺人也有恋爱的权利"，另一派则指责其"欺骗粉丝感情"。</p><p>业内人士分析认为，如果此次绯闻属实，该男星的商业代言价值可能受到严重影响。据不完全统计，其目前手握超过15个品牌代言，年商业价值超过两亿元。</p><p>我们将持续关注此事的最新进展。</p>`,
    category: "celebrity",
    categoryName: "明星爆料",
    tags: ["顶流男星", "恋爱绯闻", "酒店", "人设崩塌"],
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20dramatic%20scene%20of%20a%20luxury%20hotel%20entrance%20at%20night%20with%20paparazzi%20flash%20photography%20vibe%2C%20mysterious%20silhouette%20of%20a%20celebrity%20couple%2C%20cinematic%20lighting%20with%20warm%20golden%20tones%2C%20editorial%20style%2C%20high%20contrast%2C%20atmospheric%20mood%2C%20clean%20composition%20with%20soft%20bokeh%20background&width=800&height=450&seq=article-cover-01&orientation=landscape",
    author: "娱记小杰",
    publishedAt: "2026-08-04T10:30:00",
    views: 1285000,
    comments: 35678,
    isHot: true,
    isTrending: true,
    slug: "top-star-hotel-date-mystery-woman",
  },
  {
    id: 2,
    title: "千万粉丝网红被曝偷税漏税，税务部门已介入调查",
    excerpt: "某拥有2000万粉丝的头部网红近日被实名举报偷税漏税，涉及金额高达数千万。消息人士称税务部门已正式立案调查。",
    content: `<p>近日，一则实名举报信在网络上引起轩然大波。举报人声称，某拥有超过2000万粉丝的头部带货网红，在过去三年间通过多种手段偷逃税款，涉及金额高达数千万元。</p><p>根据举报信内容，该网红主要通过以下方式逃税：一是将个人直播收入转化为工作室收入，利用小微企业税收优惠政策避税；二是通过多个关联公司之间进行虚假交易转移利润；三是大量使用现金交易，不开发票。</p><p>消息人士透露，税务部门在接到举报后已正式立案调查。如果查实，该网红将面临补缴税款、滞纳金以及巨额罚款，严重情况下还可能面临刑事责任。</p><p>这并非网红圈首次爆出税务问题。此前已有数位头部主播因偷税漏税被追缴并罚款，金额从数百万到上亿元不等。业内专家指出，随着税务机关对直播行业监管力度不断加强，网红主播的税务合规问题将成为行业洗牌的重要因素。</p><p>该网红目前尚未对此事公开回应，但其近期直播频次明显减少，引发粉丝热议。</p>`,
    category: "internet-celebrity",
    categoryName: "网红黑料",
    tags: ["网红", "偷税漏税", "税务调查", "实名举报"],
    coverImage: "https://readdy.ai/api/search-image?query=dramatic%20news%20scene%20of%20financial%20documents%20and%20tax%20forms%20scattered%20on%20a%20modern%20desk%20with%20a%20calculator%2C%20Chinese%20social%20media%20influencer%20theme%2C%20warm%20amber%20lighting%2C%20investigative%20journalism%20mood%2C%20high%20detail%2C%20editorial%20photography%2C%20clean%20background%20with%20soft%20shadows&width=800&height=450&seq=article-cover-02&orientation=landscape",
    author: "黑料调查组",
    publishedAt: "2026-08-03T15:20:00",
    views: 965000,
    comments: 28901,
    isHot: true,
    isTrending: true,
    slug: "influencer-tax-evasion-investigation",
  },
  {
    id: 3,
    title: "某卫视知名主持人被曝婚内出轨，小三身份引发网友猜测",
    excerpt: "据知情人士爆料，某卫视一哥级主持人在婚内与多名女性保持不正当关系，其中一名疑似为同台女主持，引发全网热议。",
    content: `<p>昨日深夜，一则匿名爆料帖在某知名论坛迅速引发热议。发帖人称掌握确凿证据，某省级卫视的一哥级男主持人，在婚姻存续期间与多名女性保持不正当关系。</p><p>根据爆料帖描述，该主持人"表面上是个爱家好男人，经常在节目和社交媒体上秀恩爱，实际上私下感情生活极其混乱"。爆料人声称手中握有大量聊天记录截图和照片作为证据。</p><p>更劲爆的是，爆料人透露其中一名"小三"疑似是与该主持人在同一电视台工作的女主持人，两人利用工作之便多次私下约会。此消息一出，网友们迅速展开了"谁是那个女主持人"的猜测大赛，多位同台女主持人的社交账号被大量涌入的网友留言淹没。</p><p>该主持人的妻子是一名知名演员，两人结婚十年育有一子，一直被视为娱乐圈模范夫妻。如果爆料属实，这对"金童玉女"恐将面临婚姻危机。</p><p>截至目前，涉事各方均保持沉默，未对此事件作出任何回应。</p>`,
    category: "celebrity",
    categoryName: "明星爆料",
    tags: ["主持人", "婚内出轨", "小三", "娱乐圈"],
    coverImage: "https://readdy.ai/api/search-image?query=dramatic%20television%20studio%20scene%20with%20dim%20lighting%20and%20silhouettes%20of%20a%20male%20and%20female%20TV%20host%20standing%20apart%2C%20scandal%20theme%2C%20cinematic%20dramatic%20mood%20with%20split%20lighting%2C%20warm%20and%20cool%20contrast%2C%20editorial%20photography%20style%2C%20clean%20composition&width=800&height=450&seq=article-cover-03&orientation=landscape",
    author: "匿名爆料人",
    publishedAt: "2026-08-03T09:15:00",
    views: 1580000,
    comments: 45230,
    isHot: true,
    isTrending: true,
    slug: "tv-host-affair-scandal",
  },
  {
    id: 4,
    title: "某知名综艺节目录制现场爆发冲突，两位嘉宾大打出手",
    excerpt: "据现场观众爆料，某热门综艺最新一期录制过程中，两位常驻嘉宾因观点不合发生激烈争吵，继而演变为肢体冲突，导致录制中断两小时。",
    content: `<p>据多名现场参与录制的观众爆料，某知名卫视王牌综艺节目在最新一期录制中发生严重意外——两位常驻男嘉宾在讨论环节因观点不合发生激烈争吵，情绪失控后更是大打出手。</p><p>目击者描述，当时节目正在进行一个关于社会热点话题的辩论环节。两位嘉宾各执一词，言语交锋逐渐升温。起初大家以为是节目效果，直到其中一位嘉宾突然拍桌站起，指着对方大声辱骂，另一嘉宾也不甘示弱，上前推搡。随后两人扭打在一起，现场一度陷入混乱。</p><p>节目组工作人员迅速上前将两人拉开，但录制不得不中断约两小时。据悉，两位嘉宾随后被分别带到不同的休息室进行调解。经过节目组和双方经纪人的紧急沟通，录制最终得以继续完成，但两人的互动环节被大幅删减。</p><p>此事在观众群中引发两极反应。有人认为这完全是节目组设计的剧本和噱头，目的是制造话题吸引关注；也有人认为冲突过于真实，不像是演的。</p><p>该节目组尚未对此事件发表官方声明。</p>`,
    category: "entertainment",
    categoryName: "娱乐圈",
    tags: ["综艺节目", "嘉宾冲突", "录制事故", "打架"],
    coverImage: "https://readdy.ai/api/search-image?query=television%20variety%20show%20recording%20studio%20with%20dramatic%20tension%2C%20two%20men%20in%20heated%20confrontation%20on%20a%20colorful%20stage%20set%2C%20production%20crew%20in%20background%2C%20dramatic%20studio%20lighting%2C%20cinematic%20composition%2C%20chaotic%20atmosphere%2C%20editorial%20style&width=800&height=450&seq=article-cover-04&orientation=landscape",
    author: "综艺前线",
    publishedAt: "2026-08-02T18:45:00",
    views: 876000,
    comments: 32150,
    isHot: true,
    isTrending: false,
    slug: "variety-show-guest-fight",
  },
  {
    id: 5,
    title: "知名企业家涉嫌巨额诈骗被刑事拘留，涉案金额或超百亿",
    excerpt: "某曾被誉为商业奇才的知名企业家因涉嫌集资诈骗被警方刑事拘留，据内部消息透露，涉案金额可能超过100亿元人民币。",
    content: `<p>据权威消息源透露，某曾跻身国内富豪榜前列的知名企业家近日已被警方刑事拘留，罪名是涉嫌集资诈骗。根据内部人士透露的消息，该案件涉案金额极为惊人，可能超过100亿元人民币。</p><p>该企业家早年以创新商业模式闻名业界，其创办的公司曾在短短数年内估值突破千亿，被无数投资者追捧。然而，随着监管审查趋严，其商业模式中的灰色地带逐渐暴露。据悉，该企业家通过庞氏骗局式的手段，用后来投资者的资金支付早期投资者的回报，最终资金链断裂，大量投资者血本无归。</p><p>警方初步调查显示，受害者遍布全国多个省市，人数可能超过10万人。目前已有大量受害者在各地公安机关报案，多地警方已展开联合调查。</p><p>法律专家表示，如果指控成立，该企业家将面临十年以上有期徒刑甚至无期徒刑。此案也被业内视为近年来最大的金融犯罪案件之一。</p><p>我们将持续追踪案件的最新进展。</p>`,
    category: "business",
    categoryName: "商业内幕",
    tags: ["企业家", "集资诈骗", "刑事拘留", "金融犯罪"],
    coverImage: "https://readdy.ai/api/search-image?query=serious%20business%20news%20scene%20with%20a%20modern%20corporate%20office%20building%20at%20night%20with%20police%20car%20lights%20reflecting%2C%20financial%20crime%20investigation%20theme%2C%20dramatic%20moody%20atmosphere%2C%20dark%20corporate%20aesthetic%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=450&seq=article-cover-05&orientation=landscape",
    author: "商业调查组",
    publishedAt: "2026-08-02T11:00:00",
    views: 1120000,
    comments: 39800,
    isHot: true,
    isTrending: true,
    slug: "businessman-fraud-arrest",
  },
  {
    id: 6,
    title: "一线女星被曝整容失败，脸部浮肿拒不出门见人",
    excerpt: "某当红一线女星近期在社交平台突然停止更新，据身边工作人员透露，其因在韩国进行整容手术失败导致脸部严重浮肿，正在紧急修复中。",
    content: `<p>近期，一位当红一线女星的社交平台突然停止了更新，其微博、小红书等账号已经超过两周没有任何动态，引发粉丝担忧。据其身边工作人员匿名透露，该女星是因为在韩国进行面部整容手术时出现意外，导致脸部严重浮肿变形，目前正在韩国一家整形医院进行紧急修复。</p><p>据透露，该女星原本只是想做一个"微调"项目，但手术过程中发生了并发症，术后脸部肿胀程度远超预期，甚至出现了左右脸不对称的情况。医生表示需要至少一个月的时间才能消肿，完全恢复到自然状态可能需要三到六个月。</p><p>由于无法面对镜头和公众，该女星已取消了近期的所有商业活动和影视拍摄计划，预计损失将达数千万元。其经纪团队对外宣称是"身体不适需要休养"，但业内早已流传出整容失败的消息。</p><p>这起事件再次引发了公众对于娱乐圈整容文化的讨论。业内人士指出，在高清镜头和粉丝严格审视的压力下，越来越多的艺人选择通过医美手段维持形象，但整容风险往往被低估。</p>`,
    category: "celebrity",
    categoryName: "明星爆料",
    tags: ["女星", "整容失败", "韩国", "停工"],
    coverImage: "https://readdy.ai/api/search-image?query=beauty%20clinic%20scene%20with%20soft%20medical%20aesthetic%2C%20a%20woman%20silhouette%20looking%20in%20a%20mirror%20with%20bandages%2C%20Korean%20plastic%20surgery%20theme%2C%20moody%20dramatic%20lighting%2C%20warm%20and%20cool%20tone%20contrast%2C%20editorial%20photography%2C%20clean%20composition%20with%20soft%20shadows&width=800&height=450&seq=article-cover-06&orientation=landscape",
    author: "娱乐拆姐",
    publishedAt: "2026-08-01T14:30:00",
    views: 1450000,
    comments: 51200,
    isHot: true,
    isTrending: false,
    slug: "actress-plastic-surgery-failure",
  },
  {
    id: 7,
    title: "某科技巨头高管群内部聊天记录泄露，内容令人震惊",
    excerpt: "一组疑似某国内头部科技公司高管群的微信聊天记录在网上泄露，涉及对竞争对手的恶意抹黑计划、用户数据灰色操作以及内部权力斗争等敏感内容。",
    content: `<p>今天上午，一组疑似某国内头部科技公司高管微信群的聊天记录截图在各大社交平台疯传。这组截图涉及时间跨度长达半年，内容令人触目惊心。</p><p>根据聊天记录显示，该群成员包括公司多家核心业务线的副总裁级别以上高管。讨论内容涵盖以下几个方面：一是制定针对竞争对手的"抹黑计划"，包括在社交媒体上策划负面话题、向媒体匿名爆料等手段；二是讨论用户数据的灰色操作方式，包括如何在用户不知情的情况下收集和利用隐私数据；三是内部权力斗争，多位高管互相拉帮结派、排挤异己。</p><p>网络安全专家分析认为，此次泄露很可能来自内部人员的"报复性爆料"，而非外部黑客攻击。有消息称，泄露者可能是该公司近期被裁撤的一名高管。</p><p>如果聊天记录被证实为真，该公司可能面临严重的法律和监管风险，包括违反《反不正当竞争法》和《个人信息保护法》等多项法律法规。</p>`,
    category: "tech",
    categoryName: "科技圈",
    tags: ["科技巨头", "聊天记录泄露", "抹黑对手", "数据灰色操作"],
    coverImage: "https://readdy.ai/api/search-image?query=technology%20corporate%20office%20scene%20with%20smartphone%20displaying%20chat%20messages%20on%20a%20modern%20desk%2C%20data%20leak%20theme%2C%20dramatic%20blue%20and%20orange%20contrast%20lighting%2C%20cyber%20security%20mood%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=450&seq=article-cover-07&orientation=landscape",
    author: "科技深喉",
    publishedAt: "2026-08-01T09:00:00",
    views: 890000,
    comments: 26700,
    isHot: false,
    isTrending: true,
    slug: "tech-giant-exec-chat-leak",
  },
  {
    id: 8,
    title: "某知名导演被多名女演员联合举报性骚扰，业内掀起MeToo浪潮",
    excerpt: "三位曾与该导演合作过的女演员先后在社交媒体发声，指控该导演在拍摄期间对其进行了不同程度的性骚扰。目前已有超过50位业内人士联名支持举报者。",
    content: `<p>近日，娱乐圈再掀MeToo浪潮。三位曾与某知名导演合作过的女演员先后通过个人社交媒体发布长文，详细描述了在合作期间遭受的性骚扰经历。</p><p>第一位发声的女演员A表示，在拍摄某部电影期间，该导演多次以"讲戏"为由深夜约她到酒店房间，对她进行言语挑逗和肢体接触。当她拒绝后，该导演便以删减戏份为威胁，让她"想清楚后果"。</p><p>第二位女演员B的遭遇更为严重。她声称在拍摄一场亲密戏时，该导演以"追求真实效果"为由，在没有事先沟通的情况下临时增加了大量越界动作，让她感到极度不适和被冒犯。</p><p>第三位则是刚入行不久的新人演员，她表示导演以"提供演艺机会"为诱饵，多次试图与她建立不正当关系。</p><p>截至目前，已有超过50位业内人士联名发表公开信支持三位女演员，呼吁行业建立更完善的性骚扰防范机制。该导演尚未作出任何回应，但其参与的多部新片已传出换人消息。</p>`,
    category: "entertainment",
    categoryName: "娱乐圈",
    tags: ["导演", "性骚扰", "MeToo", "女演员"],
    coverImage: "https://readdy.ai/api/search-image?query=film%20set%20scene%20with%20dramatic%20spotlight%20and%20silhouettes%2C%20movie%20director%20chair%20empty%20on%20a%20dark%20stage%2C%20MeToo%20movement%20theme%2C%20powerful%20dramatic%20atmosphere%2C%20high%20contrast%20lighting%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=450&seq=article-cover-08&orientation=landscape",
    author: "女性权益观察",
    publishedAt: "2026-07-31T16:00:00",
    views: 1890000,
    comments: 67800,
    isHot: true,
    isTrending: true,
    slug: "director-sexual-harassment-metoo",
  },
  {
    id: 9,
    title: "选秀节目冠军被曝学历造假，人设全面崩塌",
    excerpt: "某知名选秀节目冠军选手被扒出学历造假，其宣称的海外名校硕士学历实为短期培训班结业证书。此外，其富二代人设也疑似造假。",
    content: `<p>今日，一则关于某知名选秀节目冠军选手学历造假的爆料在互联网上迅速发酵。据多位网友联合考证，该选手一直对外宣称的"美国某常春藤名校硕士学历"实际上只是一所语言培训机构的短期课程结业证书。</p><p>爆料显示，该选手在参赛期间及后续的多次采访中均表示自己毕业于美国某知名大学，并获得了硕士学位。这一"学霸"人设为其赢得了大量粉丝的喜爱和崇拜。然而，近日有留学生网友发现，在该大学的校友名录中根本找不到该选手的名字。</p><p>进一步的调查发现，该选手确实曾在美国生活过一段时间，但就读的只是一所私立语言培训学校，所获的也仅仅是该学校自己颁发的结业证明，与正规学历完全不是一回事。</p><p>此外，该选手一直维持的"富二代"人设也受到了质疑。多名自称是其中学同学的网友爆料称，其家庭条件实际上非常普通，其父亲只是一名普通职员，而非其声称的"上市公司高管"。</p><p>面对铺天盖地的质疑，该选手的经纪公司仅发布了一则简短声明，称"关于学历问题的部分信息不实，保留追究法律责任的权利"，但并未提供任何实质性证据，引发更多网友不满。</p>`,
    category: "internet-celebrity",
    categoryName: "网红黑料",
    tags: ["选秀冠军", "学历造假", "人设崩塌", "富二代"],
    coverImage: "https://readdy.ai/api/search-image?query=graduation%20ceremony%20theme%20with%20a%20diploma%20and%20cap%20on%20a%20dark%20background%2C%20educational%20fraud%20concept%2C%20dramatic%20lighting%20with%20shadows%2C%20investigative%20journalism%20mood%2C%20editorial%20photography%2C%20clean%20composition%20with%20golden%20accents&width=800&height=450&seq=article-cover-09&orientation=landscape",
    author: "教育打假人",
    publishedAt: "2026-07-31T10:30:00",
    views: 1020000,
    comments: 38900,
    isHot: true,
    isTrending: false,
    slug: "talent-show-winner-fake-degree",
  },
  {
    id: 10,
    title: "政府高官之子在海外挥金如土，豪车豪宅曝光引众怒",
    excerpt: "某中央部委高级官员之子在海外社交媒体频繁晒出奢华生活，包括多处豪宅、限量超跑以及私人游艇，引发公众对其家庭财产来源的质疑。",
    content: `<p>近日，一组从海外社交媒体流传回国内的炫富照片和视频在网络上引发轩然大波。主角是某中央部委高级官员的独生子，其在国外社交平台上频繁发布展示奢华生活的内容。</p><p>根据其发布的动态，该"官二代"在洛杉矶、纽约和伦敦分别拥有豪宅，车库里停放着包括法拉利、兰博基尼、劳斯莱斯在内的多辆限量版超跑，总价值超过5000万人民币。此外，他还多次晒出乘坐私人游艇出海度假的照片，生活之奢靡令人咋舌。</p><p>按照其父亲公开的公务员薪资水平计算，即便是全家人不吃不喝一辈子，也难以支撑如此奢靡的开销。这一矛盾迅速引发了公众对官员家庭财产来源合法性的质疑。</p><p>目前，相关监管部门已表示将对此事展开调查。舆论普遍认为，这起事件再次暴露了公职人员财产申报和监督机制的漏洞。</p>`,
    category: "politics",
    categoryName: "政商秘闻",
    tags: ["官二代", "炫富", "海外资产", "反腐"],
    coverImage: "https://readdy.ai/api/search-image?query=luxury%20lifestyle%20scene%20with%20expensive%20sports%20cars%20and%20modern%20mansion%20exterior%20at%20sunset%2C%20wealth%20display%20theme%2C%20dramatic%20golden%20hour%20lighting%2C%20investigative%20journalism%20mood%2C%20editorial%20photography%2C%20clean%20composition%20with%20warm%20tones&width=800&height=450&seq=article-cover-10&orientation=landscape",
    author: "廉政观察",
    publishedAt: "2026-07-30T20:00:00",
    views: 2350000,
    comments: 89500,
    isHot: true,
    isTrending: true,
    slug: "official-son-luxury-lifestyle-exposed",
  },
  {
    id: 11,
    title: "知名带货主播直播间翻车，产品质量遭全网声讨",
    excerpt: "某拥有三千万粉丝的头部带货主播在直播中推荐的一款护肤品被大量用户反映使用后出现严重过敏反应，引发集体维权。",
    content: `<p>某拥有超过3000万粉丝的头部带货主播近日遭遇了一场严重的信任危机。其在一场观看人次超过1000万的直播中力荐的一款国产护肤品，被大量消费者反映使用后出现严重过敏反应。</p><p>截至目前，已有超过2000名消费者在投诉平台上联合维权。据消费者描述，使用该产品后出现了面部红肿、刺痛、脱皮甚至溃烂等症状。多位消费者提供了医院诊断证明，证实其症状与使用该产品存在直接因果关系。</p><p>该主播在事件发酵两天后才发布道歉声明，表示已第一时间联系品牌方下架产品，并承诺协助消费者维权。然而，消费者并不买账，纷纷质疑其选品流程和推荐的真实性。有网友扒出该主播此前多次推荐翻车产品的记录，质疑其"只拿钱不把关"。</p><p>业内人士指出，随着直播带货行业野蛮生长，主播为追求佣金不惜推荐劣质产品的问题日益严重。此次事件或将推动行业出台更严格的选品审核标准。</p>`,
    category: "internet-celebrity",
    categoryName: "网红黑料",
    tags: ["直播带货", "产品质量", "过敏", "维权"],
    coverImage: "https://readdy.ai/api/search-image?query=live%20streaming%20ecommerce%20studio%20with%20beauty%20products%20displayed%20on%20a%20table%2C%20smartphone%20showing%20live%20stream%20interface%2C%20product%20quality%20scandal%20theme%2C%20dramatic%20studio%20lighting%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=450&seq=article-cover-11&orientation=landscape",
    author: "消费者权益",
    publishedAt: "2026-07-30T14:00:00",
    views: 780000,
    comments: 29500,
    isHot: false,
    isTrending: true,
    slug: "livestreamer-product-quality-scandal",
  },
  {
    id: 12,
    title: "某著名慈善家被曝善款挪用，慈善机构沦为洗钱工具",
    excerpt: "一位以慈善著称的商界大佬被匿名举报其名下的慈善基金会存在严重的善款挪用问题，疑似将慈善资金用于个人消费和商业投资。",
    content: `<p>一位长期以"大慈善家"形象示人的商界大佬近日被匿名举报，其名下的慈善基金会存在严重的善款挪用问题。举报材料中包含了大量财务文件，显示该基金会多年来的善款使用存在重大疑点。</p><p>根据举报材料，该基金会每年收到的善款超过5亿元，但实际用于慈善项目的资金不足30%。大量资金被以"管理费"、"咨询费"等名义转移至与该慈善家本人有关联的企业账户。此外，举报还指出该基金会利用慈善项目在海外进行可疑的大额资金转移，疑似涉及跨境洗钱。</p><p>更令人震惊的是，该慈善家曾利用基金会的资金购买了一架私人飞机，对外却宣称是企业捐赠。而其在北京郊区的一处豪华庄园，也被查明是通过基金会间接出资购买的。</p><p>民政部门已宣布将对该基金会展开专项审计调查。如果举报属实，这将是近年来最大的慈善丑闻之一。</p>`,
    category: "social",
    categoryName: "社会热点",
    tags: ["慈善", "善款挪用", "基金会", "洗钱"],
    coverImage: "https://readdy.ai/api/search-image?query=charity%20foundation%20office%20with%20documents%20and%20financial%20reports%20scattered%20on%20a%20desk%2C%20fraud%20investigation%20theme%2C%20dramatic%20lighting%20with%20shadows%2C%20moody%20atmosphere%2C%20editorial%20photography%2C%20clean%20composition%20with%20warm%20amber%20tones&width=800&height=450&seq=article-cover-12&orientation=landscape",
    author: "公益监督",
    publishedAt: "2026-07-29T08:00:00",
    views: 1560000,
    comments: 51200,
    isHot: true,
    isTrending: true,
    slug: "charity-founder-fund-misuse",
  },
  {
    id: 13,
    title: "某顶流女团成员被爆霸凌队友，团队内部关系破裂",
    excerpt: "据多名内部工作人员爆料，某当红女团中人气最高的成员长期对队友进行言语霸凌和精神打压，导致团队内部关系极度紧张。",
    content: `<p>今天，一则关于某当红女团内部霸凌的爆料在韩娱和内娱粉丝圈同时炸开了锅。据多名曾与该女团合作过的化妆师、造型师和经纪人爆料，该团中人气最高的"ACE"成员长期对队友实施言语霸凌和精神打压。</p><p>爆料人描述了多个令人不适的场景：在化妆间里，这位成员当众嘲笑队友"长得丑还当什么偶像"；在排练时，多次用尖锐的语言批评队友"跳得太差拖大家后腿"；甚至在粉丝面前也毫不掩饰对队友的轻蔑态度。据称，多位队友因此出现了不同程度的心理问题，有的甚至在演出前需要服用镇静药物。</p><p>爆料还指出，团队经纪公司对此情况早已知情，但出于商业利益考虑选择了默许和纵容，甚至帮助该成员打压表达不满的受害者。</p><p>目前，相关话题已在各大社交平台登上热搜。大量粉丝表示震惊和失望，要求经纪公司和涉事成员公开道歉。</p>`,
    category: "entertainment",
    categoryName: "娱乐圈",
    tags: ["女团", "霸凌", "队友", "偶像"],
    coverImage: "https://readdy.ai/api/search-image?query=K-pop%20style%20girl%20group%20performance%20stage%20with%20dramatic%20spotlight%2C%20one%20member%20standing%20apart%20from%20others%2C%20bullying%20theme%2C%20emotional%20tension%2C%20cinematic%20lighting%2C%20editorial%20photography%2C%20clean%20composition%20with%20cool%20and%20warm%20contrast&width=800&height=450&seq=article-cover-13&orientation=landscape",
    author: "韩娱前线",
    publishedAt: "2026-07-29T11:00:00",
    views: 1680000,
    comments: 62300,
    isHot: true,
    isTrending: true,
    slug: "girl-group-bullying-scandal",
  },
  {
    id: 14,
    title: "房地产大佬海外转移资产被限出境，百亿资金被冻结",
    excerpt: "某知名房地产集团创始人被曝计划将数百亿资产转移至海外，被监管部门及时发现并限制出境。目前其名下多个银行账户已被冻结。",
    content: `<p>据知情人士透露，某曾位列中国房企前十的知名地产集团创始人，近期试图将数百亿资产转移至海外，被金融监管部门及时发现并紧急叫停。目前该创始人已被限制出境，其名下多个境内外银行账户已被冻结。</p><p>消息人士称，该地产大佬在过去一年间，通过复杂的离岸公司架构和地下钱庄网络，已经成功转移了部分资产至国外。监管部门在监控到异常资金流动后迅速行动，阻止了更大规模的资产外逃。</p><p>该地产集团目前正面临严峻的债务危机，总负债超过2000亿元人民币，多条业务线已基本停摆。而创始人在公司危难之际试图"金蝉脱壳"的行为，引发了债权人和社会各界的强烈愤慨。</p><p>法律专家表示，在企业面临破产清算时转移资产的行为可能构成"抽逃出资"和"恶意逃避债务"，相关责任人将面临严重的法律后果。</p>`,
    category: "business",
    categoryName: "商业内幕",
    tags: ["房地产", "资产转移", "限出境", "债务危机"],
    coverImage: "https://readdy.ai/api/search-image?query=modern%20skyscraper%20office%20building%20with%20dark%20stormy%20sky%2C%20real%20estate%20crisis%20theme%2C%20dramatic%20moody%20atmosphere%2C%20financial%20distress%20concept%2C%20editorial%20photography%2C%20clean%20composition%20with%20cool%20gray%20tones&width=800&height=450&seq=article-cover-14&orientation=landscape",
    author: "财经观察",
    publishedAt: "2026-07-28T16:30:00",
    views: 1340000,
    comments: 44500,
    isHot: true,
    isTrending: false,
    slug: "real-estate-tycoon-asset-transfer",
  },
  {
    id: 15,
    title: "知名大学校长被举报学术不端，多篇论文涉嫌抄袭",
    excerpt: "某知名985高校校长被实名举报存在严重的学术不端行为，其发表的十余篇论文被指大量抄袭国外学者研究成果，目前教育部已介入调查。",
    content: `<p>今日，一封实名举报信在教育界和学术界引发强烈震动。举报人——该校一名不愿透露姓名的教授——指控其所在985高校的校长存在严重的学术不端行为。</p><p>举报信详细列举了该校长发表的十余篇学术论文中存在的抄袭问题。据举报人通过专业查重软件对比，这些论文中有大量段落直接翻译自国外学者的英文论文，但未做任何引用标注。其中一篇被誉为该校长"代表作"的论文，查重率高达67%。</p><p>更严重的是，举报人指出该校长利用其行政权力，打压和排挤举报其学术不端行为的教师，并利用职权为有问题的论文打通了发表渠道和评审环节。</p><p>教育部已回应称已收到相关举报材料，将组建专家调查组对该事件进行全面调查。如果查实，该校长将面临撤销学位、免去行政职务等严厉处罚。</p>`,
    category: "social",
    categoryName: "社会热点",
    tags: ["大学校长", "学术不端", "论文抄袭", "实名举报"],
    coverImage: "https://readdy.ai/api/search-image?query=university%20campus%20library%20scene%20with%20books%20and%20academic%20papers%20scattered%2C%20academic%20fraud%20theme%2C%20dramatic%20lighting%20with%20warm%20library%20tones%2C%20investigative%20theme%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=450&seq=article-cover-15&orientation=landscape",
    author: "学术打假",
    publishedAt: "2026-07-28T10:00:00",
    views: 920000,
    comments: 35400,
    isHot: false,
    isTrending: true,
    slug: "university-president-academic-fraud",
  },
  {
    id: 16,
    title: "某流量小生被拍与女经纪人密会，年龄差超15岁引争议",
    excerpt: "当红流量小生被狗仔拍到深夜与比自己大15岁的女经纪人同返公寓，两人的亲密举动引发恋情猜测。粉丝激烈反对这段姐弟恋。",
    content: `<p>昨日，知名狗仔团队"风行摄影"曝光了一组偷拍照片，当红99年出生的流量小生W某被拍到深夜与年长女经纪人同返其居住的公寓。照片显示两人全程举止亲密，女方多次挽着男方的手臂，疑似恋情曝光。</p><p>据悉，该女经纪人比W某大15岁，是业内知名的金牌经纪人，曾一手捧红多位艺人。两人合作已有三年时间，此前外界一直认为他们只是纯粹的经纪约关系。</p><p>这组照片曝光后，W某的粉丝群体迅速炸锅。大量粉丝表示强烈反对这段恋情，认为"年龄差距太大不合适"，甚至有人直接攻击女方"老牛吃嫩草"。但也有理性的声音认为艺人也有恋爱的自由选择权。</p><p>截至目前，W某工作室尚未发布任何回应。但有网友发现，照片曝光后不久，女经纪人的社交账号已设置为私密。</p>`,
    category: "celebrity",
    categoryName: "明星爆料",
    tags: ["流量小生", "姐弟恋", "经纪人", "恋情曝光"],
    coverImage: "https://readdy.ai/api/search-image?query=urban%20night%20street%20scene%20with%20a%20couple%20silhouette%20walking%20toward%20an%20apartment%20building%2C%20paparazzi%20photography%20style%2C%20dramatic%20street%20lighting%2C%20romantic%20yet%20controversial%20mood%2C%20editorial%20photography%2C%20clean%20composition%20with%20warm%20night%20tones&width=800&height=450&seq=article-cover-16&orientation=landscape",
    author: "风行摄影",
    publishedAt: "2026-07-27T22:00:00",
    views: 2100000,
    comments: 78200,
    isHot: true,
    isTrending: true,
    slug: "young-actor-older-manager-romance",
  },
  {
    id: 17,
    title: "某互联网大厂被曝强制加班致员工猝死，家属索赔千万",
    excerpt: "某头部互联网公司一名28岁程序员疑因长期超负荷加班导致过劳猝死，家属爆料公司存在\"996是福报\"的畸形加班文化，已提起诉讼索赔。",
    content: `<p>近日，一起互联网大厂员工猝死事件在网络上引发广泛讨论。某头部互联网公司的一名28岁程序员在连续加班两周后，于工位上突发心脏骤停，经抢救无效不幸离世。</p><p>据该员工的家属透露，他在世时几乎每天都要工作12小时以上，经常凌晨两三点才能下班回家。出事的那个月，他整整加了200多个小时的班。家属还曝光了该公司内部的工作群聊天记录，显示管理层以"996是福报"、"年轻人就该拼"等口号鼓励员工持续高强度工作。</p><p>更令人心寒的是，事件发生后，该公司第一时间并不是慰问家属，而是试图通过签署保密协议和给予少量赔偿金来"私了"。当家属拒绝了50万元的赔偿方案后，公司便态度大变，甚至威胁要追究死者的"泄密责任"。</p><p>目前，家属已委托律师提起诉讼，向该公司索赔1000万元，并要求公开道歉。该事件也引发了社会对企业加班文化的再次反思。</p>`,
    category: "tech",
    categoryName: "科技圈",
    tags: ["互联网大厂", "过劳死", "加班文化", "索赔"],
    coverImage: "https://readdy.ai/api/search-image?query=modern%20tech%20office%20at%20night%20with%20dim%20lights%20and%20empty%20cubicles%2C%20overwork%20theme%2C%20lonely%20atmosphere%2C%20dramatic%20moody%20lighting%2C%20editorial%20photography%2C%20clean%20composition%20with%20cool%20blue-gray%20tones&width=800&height=450&seq=article-cover-17&orientation=landscape",
    author: "劳动权益",
    publishedAt: "2026-07-27T13:00:00",
    views: 1750000,
    comments: 68900,
    isHot: true,
    isTrending: true,
    slug: "tech-company-overwork-death",
  },
  {
    id: 18,
    title: "网红奶茶品牌被曝使用过期原料，后厨环境触目惊心",
    excerpt: "某年营收数十亿的网红奶茶品牌被卧底记者曝光多家门店使用过期原材料、篡改保质期标签，后厨卫生状况令人作呕。",
    content: `<p>今天上午，一则卧底调查报道让某知名网红奶茶品牌陷入了严重危机。据记者长达两个月的卧底调查，该品牌在北京、上海、广州的多家门店均存在使用过期原材料的严重食品安全问题。</p><p>根据偷拍画面显示，店员在明知原材料已过期的情况下，仍将其用于制作饮品。过期的牛奶、变质的珍珠、发霉的水果，一切都在消费者不知情的情况下被做成了一杯杯价格不菲的网红奶茶。更令人愤怒的是，店员还擅自修改保质期标签，以应付检查。</p><p>此外，后厨的卫生状况也触目惊心：老鼠蟑螂横行、设备布满污垢、食材直接堆放在地面上。而这一切，都与该品牌在广告中宣传的"天然、健康、新鲜"的形象形成鲜明对比。</p><p>市场监督管理局已紧急对涉事门店进行突击检查，部分门店被责令停业整顿。该品牌股价在消息公布后暴跌超过20%。</p>`,
    category: "social",
    categoryName: "社会热点",
    tags: ["奶茶", "食品安全", "过期原料", "卧底调查"],
    coverImage: "https://readdy.ai/api/search-image?query=milk%20tea%20shop%20kitchen%20scene%20with%20messy%20counter%20and%20expired%20ingredients%2C%20food%20safety%20scandal%20theme%2C%20dramatic%20investigative%20lighting%2C%20dirty%20kitchen%20environment%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=450&seq=article-cover-18&orientation=landscape",
    author: "食品安全调查",
    publishedAt: "2026-07-26T08:00:00",
    views: 1980000,
    comments: 72100,
    isHot: true,
    isTrending: false,
    slug: "popular-tea-brand-expired-ingredients",
  },
  {
    id: 19,
    title: "揭秘某省首富的发家史：靠侵吞国有资产起家",
    excerpt: "一份解密的历史档案揭露了某省首富在上世纪90年代国企改制期间，通过不正当手段低价获取巨额国有资产的内幕。",
    content: `<p>近日，一份尘封多年的历史档案被解密，揭示了某省首富在上世纪90年代国企改制浪潮中的发家"秘史"。根据档案显示，该首富当时利用其担任国企负责人的职务之便，通过一系列低估资产、收买评估机构、串通审批官员等不正当手段，将价值数十亿的国有资产以极低价格转入个人名下。</p><p>档案详细记录了多笔可疑交易的细节：一家年利润超过5000万的优质国企，经过一连串"运作"后，被评估为"资不抵债"，最终以不到实际价值1%的价格被收购。其中涉及的"过手费"和"关系维护费用"也有清晰记录。</p><p>如今，该首富名下的产业已涵盖房地产、金融、能源等多个领域，个人财富超过千亿。然而，其发家的"原罪"一直受到质疑。此前也有过多次举报，但均因"证据不足"而不了了之。</p><p>法律界人士指出，即便是发生在几十年前的行为，如果构成犯罪且在追诉时效内，仍有可能被追究法律责任。</p>`,
    category: "business",
    categoryName: "商业内幕",
    tags: ["首富", "国有资产", "国企改制", "发家史"],
    coverImage: "https://readdy.ai/api/search-image?query=old%20factory%20industrial%20scene%20from%201990s%20China%2C%20state-owned%20enterprise%20reform%20theme%2C%20vintage%20photograph%20style%2C%20dramatic%20contrast%20lighting%2C%20historical%20documentary%20mood%2C%20editorial%20photography%2C%20clean%20composition%20with%20warm%20sepia%20tones&width=800&height=450&seq=article-cover-19&orientation=landscape",
    author: "历史档案解密",
    publishedAt: "2026-07-26T15:00:00",
    views: 890000,
    comments: 31200,
    isHot: false,
    isTrending: false,
    slug: "richest-man-state-asset-theft",
  },
  {
    id: 20,
    title: "某短视频平台被曝算法操纵情绪，刻意推送负面内容",
    excerpt: "一位前员工爆料某头部短视频平台利用算法刻意向用户推送引发焦虑和愤怒的内容，以增加用户停留时长和广告收入。内部文件截图流出。",
    content: `<p>今天，一位自称是某头部短视频平台前高级工程师的匿名爆料人在技术论坛上发布了一篇长文，并附上了多张内部文档截图，揭示了该平台内容推荐算法的惊人内幕。</p><p>根据内部文件显示，该平台的算法系统有一个被称为"情绪引擎"的核心模块，其作用是实时评估每一条内容所引发的用户情绪反应，并优先推荐那些能够引发强烈负面情绪（如愤怒、焦虑、恐惧、嫉妒）的内容。原因是数据分析表明，负面情绪内容能够使用户在平台上的停留时间延长约35%，进而带来更多的广告收入。</p><p>更令人不安的是，算法还会根据用户的情绪状态进行微调。当检测到用户在负面情绪内容上停留时间过长时，算法会暂时推送一些"治愈系"内容防止用户彻底流失，但很快又会重新引导回负面情绪内容。这种被内部称为"情绪过山车"的策略，被证明是最大化用户粘性的最有效手段。</p><p>此事在社交媒体上引发了对算法伦理的广泛讨论。多位学者呼吁尽快出台算法推荐内容的监管法规。</p>`,
    category: "tech",
    categoryName: "科技圈",
    tags: ["短视频", "算法操纵", "情绪操控", "内部爆料"],
    coverImage: "https://readdy.ai/api/search-image?query=digital%20algorithm%20visualization%20with%20glowing%20data%20nodes%20and%20connections%20on%20a%20dark%20background%2C%20social%20media%20manipulation%20theme%2C%20futuristic%20yet%20ominous%20atmosphere%2C%20dramatic%20tech%20lighting%2C%20editorial%20photography%20style%2C%20clean%20composition&width=800&height=450&seq=article-cover-20&orientation=landscape",
    author: "技术伦理观察",
    publishedAt: "2026-07-25T17:00:00",
    views: 720000,
    comments: 26800,
    isHot: false,
    isTrending: false,
    slug: "short-video-platform-algorithm-manipulation",
  },
];

export function getArticlesByCategory(categorySlug: string): Article[] {
  if (categorySlug === "all") return articles;
  return articles.filter((a) => a.category === categorySlug);
}

export function getArticleById(id: number): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getHotArticles(limit: number = 5): Article[] {
  return articles.filter((a) => a.isHot).slice(0, limit);
}

export function getTrendingArticles(limit: number = 6): Article[] {
  return articles.filter((a) => a.isTrending).slice(0, limit);
}

export function getLatestArticles(limit: number = 10): Article[] {
  return [...articles].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
  ).slice(0, limit);
}

export function getRelatedArticles(article: Article, limit: number = 4): Article[] {
  return articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .slice(0, limit);
}